var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "transfer-dom", rawName: "v-transfer-dom" }],
      attrs: { "data-transfer": _vm.transfer }
    },
    [
      _c("transition", { attrs: { name: _vm.transitionNames[1] } }, [
        _vm.showMask
          ? _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible"
                }
              ],
              class: _vm.maskClasses,
              style: _vm.wrapStyles,
              on: { click: _vm.handleMask }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.wrapClasses,
          style: _vm.wrapStyles,
          on: { click: _vm.handleWrapClick }
        },
        [
          _c(
            "transition",
            {
              attrs: { name: _vm.transitionNames[0] },
              on: { "after-leave": _vm.animationFinish }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.visible,
                      expression: "visible"
                    }
                  ],
                  class: _vm.classes,
                  style: _vm.mainStyles,
                  on: { mousedown: _vm.handleMousedown }
                },
                [
                  _c(
                    "div",
                    {
                      ref: "content",
                      class: _vm.contentClasses,
                      style: _vm.contentStyles,
                      on: { click: _vm.handleClickModal }
                    },
                    [
                      _vm.closable
                        ? _c(
                            "a",
                            {
                              class: [_vm.prefixCls + "-close"],
                              on: { click: _vm.close }
                            },
                            [
                              _vm._t("close", function() {
                                return [
                                  _c("Icon", { attrs: { type: "ios-close" } })
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showHead
                        ? _c(
                            "div",
                            {
                              class: [_vm.prefixCls + "-header"],
                              on: { mousedown: _vm.handleMoveStart }
                            },
                            [
                              _vm._t("header", function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      class: [_vm.prefixCls + "-header-inner"]
                                    },
                                    [_vm._v(_vm._s(_vm.title))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: [_vm.prefixCls + "-body"] },
                        [_vm._t("default")],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.footerHide
                        ? _c(
                            "div",
                            { class: [_vm.prefixCls + "-footer"] },
                            [
                              _vm._t("footer", function() {
                                return [
                                  _c(
                                    "i-button",
                                    {
                                      attrs: { type: "text" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.cancel.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.localeCancelText))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        loading: _vm.buttonLoading
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.ok.apply(null, arguments)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.localeOkText))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f789fa1", { render: render, staticRenderFns: staticRenderFns })
  }
}